import React from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl, makeStyles } from '@material-ui/core';
import { blackColor, formElementBaseBgColor } from 'assets/jss/material-dashboard-pro-react';
import { useDispatch, useSelector } from 'react-redux';
import { getLanguageSwitcherLabels } from 'redux/modules/dynamicLabels/selectors';
import { fetchLabels } from 'utils/labels/labels';
import { setLanguage } from 'redux/modules/settings/language/actions';
import { getLanguage } from 'utils/language/language';
import classNames from 'classnames';

const useStyles = makeStyles({
	radio: {
		color: formElementBaseBgColor,
		'&$checked': {
			color: formElementBaseBgColor,
		},
	},
	fieldset: {
		width: '100%',
		padding: '0 1.5rem',
		marginTop: '2rem',
	},
	checked: {},
	label: {
		fontFamily: 'inherit',
		color: blackColor,
		'&$checked': {
			fontWeight: 'bold',
		},
	},
	radioGroup: {
		'& label': {
			flex: 1,
		},
	},
});

const LanguageSelector: React.FC = () => {
	const classes = useStyles();
	const languageSwitcherLabels = useSelector(getLanguageSwitcherLabels);
	const dispatch = useDispatch();
	const selectedLanguage: types.redux.settings.language = getLanguage();

	const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		fetchLabels(event.target.value);
		dispatch(setLanguage(event.target.value));
	};

	return (
		<FormControl component="fieldset" className={classes.fieldset}>
			<RadioGroup
				row
				aria-label={languageSwitcherLabels?.switchLanguage}
				name="language"
				value={selectedLanguage}
				onChange={handleLanguageChange}
				className={classes.radioGroup}
			>
				<FormControlLabel
					value="en"
					control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
					label={languageSwitcherLabels?.lang_english}
					classes={{
						label: classNames(classes.label, {
							[classes.checked]: selectedLanguage === 'en',
						}),
					}}
				/>
				<FormControlLabel
					value="ar"
					control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
					label={languageSwitcherLabels?.lang_arabic}
					classes={{
						label: classNames(classes.label, {
							[classes.checked]: selectedLanguage === 'ar',
						}),
					}}
				/>
			</RadioGroup>
		</FormControl>
	);
};

export default LanguageSelector;
